// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useMemo , useEffect , createContext , useContext} from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef
} from 'material-react-table';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import logo from '../../TIP_tate.svg';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link, useLocation  } from 'react-router-dom';
import {useIntl  , FormattedMessage } from 'react-intl';
import {loginC2,c2,loginDl,loginPhish,phish,dl,loginHash,hash}  from "./data/tdb_c2";
import { DataGrid, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import "../../index.css";
import { colors } from '@mui/material';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import AppAppBar from './AppAppBar';
import ReactGA from "react-ga4";
ReactGA.initialize("G-1ZP16CT4G0");
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import Login from './Login'
import {LoginContext,LoadingContext} from '../Default';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import {stix} from './data/tdb_c2.tsx';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const xs = stix;
const rows = [
  {
    id: 1,
    name: 'MUI',
    stars: 28000,
  },
  {
    id: 2,
    name: 'DataGrid',
    stars: 15000,
  },  
];
const columns2 = [
  {width: 15,renderCell: (params) => ""},
  { field: 'colmn1', width: 450 },
  { field: 'colmn2', width: 450 }
];

const columns3 = [
  { field: 'name' },
  { field: 'url' },
  { field: 'aliases' },
];

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));
const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '1px solid',
  boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
  backgroundImage: `url(${'/static/images/templates/templates-images/hero-light.png'})`,
  outlineColor: 'hsla(220, 25%, 80%, 0.5)',
  backgroundSize: 'cover',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
    height: 700,
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 24px 12px hsla(210, 100%, 25%, 0.2)',
    backgroundImage: `url(${'/static/images/templates/templates-images/hero-dark.png'})`,
    outlineColor: 'hsla(210, 100%, 80%, 0.1)',
  }),
}));
const styles = (theme: { spacing: { unit: number; }; shape: { borderRadius: any; }; breakpoints: { up: (arg0: string) => any; }; transitions: { create: (arg0: string) => any; }; }) => ({
  root: {
  },
  textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 200,
  },
  search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing.unit,
          width: 'auto',
      },
  },
  searchIcon: {
      width: theme.spacing.unit * 9,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  },
  inputRoot: {
      color: 'inherit',
      width: '100%',
  },
  inputInput: {
      paddingTop: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 10,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          width: 120,
          '&:focus': {
              width: 200,
          },
      },
  },
});


function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function SearchResult() {
  const intl = useIntl();
  let locale;
  if(intl.locale == "ja"){
    locale = MRT_Localization_JA
  }else{
    locale = MRT_Localization_EN
  }
  const location = useLocation();
  const [category, setCategory] = React.useState(location.state!==null&&location.state.hasOwnProperty("category") ? location.state["category"] : "0");
  const [keyword, setKeyword] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "");
  if(location.state == null){
    const err = document.getElementById("sc");
    err?.click();
  }
  const [table, settable] = React.useState(location.state!==null&&location.state.hasOwnProperty("table") ? location.state["table"] : []);
  const isEditing = location.state!==null&&location.state.hasOwnProperty("pp")&& location.state["pp"]== 0 ? true: false ;
  const cell = location.state!==null&&location.state.hasOwnProperty("pp")? location.state["cell"]: "" ;
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open3_2, setOpen3_2] = React.useState(false);
  const msg = intl.formatMessage({ id: "langID00058" });
  const context = useContext(LoginContext);
  const {login,setLogain} = useContext(LoginContext);
  const {loading,setLoading} = useContext(LoadingContext);
  const [tableCategory, setTableCategory] = React.useState("1");
  const [tableName, setTableName] = React.useState("");
  const [cutFlag, setCutFlag] = React.useState(false);
  const [cutFlag2, setCutFlag2] = React.useState(false);
  const [actorFlag, setActorFlag] = React.useState(false);
  const [actorFlag2, setActorFlag2] = React.useState(false);
  const [data2_3, setData2_3] = React.useState([]);
  const [data3_3, setData3_3] = React.useState([]);
  const [stix1, setStix1] = React.useState([]);
  const [stix2, setStix2] = React.useState([]);
  const [relationData, setRelationData] = React.useState([]);
  const [relationLoad, setRelationLoad] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const resData = async (): Promise<Post[]> => {
    if(!loading){
    const url = process.env.REACT_APP_GET_DATA_API_URL;
    try{
    const bodyData = {
      category: "5",
      keyword: table.dtl._id[0],
      type:table.category,
      login:login
    };
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
        
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
    });;
    //setLoading(false);
    }catch{
      setLoading(false);
    }
    }
};
  const resData2 = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_GET_DATA_API_URL;
    try{
    const bodyData = {
      category: "6",
      keyword:table.dtl._id[0] ,
      keywordSub:cell,
      type:table.category,
      login:login
    };
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
        
  //setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        //setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      //setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
    });;
    //setLoading(false);
    }catch{
      setLoading(false);
      //setLoading(false);
    }
};
   const dataAdd = (list: any): {}[] => {
    let datasub=[];
    let datasubA=[];
    let actorFlagSub = false;
        let num = 1;
        let addData={};
        let addDataA={};
        for (let key in list) {
          if(list[key].colmn2=="nodata"){
            addData= {
               "id":num,
               "colmn1":intl.formatMessage({ id: list[key].colmn1 }),
               "colmn2":msg
                };
            }else if(list[key].colmn1=="langID00066"){
                setActorFlag(true);
                actorFlagSub = true;
                let cnt = list[key].colmn2.length +" " + intl.formatMessage({ id: "langID00069" })
                setData2_3([{
               "id":"actor",
               "colmn1":intl.formatMessage({ id: list[key].colmn1 }),
               "colmn2":cnt
                }]);
                let sub3 = []
                let s3 = []
                for (let keysub in list[key].colmn2) {
                  sub3 ={
                    "name":list[key].colmn2[keysub].name,
                    "aliases":list[key].colmn2[keysub].aliases,
                    "url":list[key].colmn2[keysub].url
                };
                s3.push(sub3);
                }
                setStix1(s3);
                continue;
            }else{
               addData= {
               "id":num,
               "colmn1":intl.formatMessage({ id: list[key].colmn1 }),
               "colmn2":list[key].colmn2
                };
            }
              datasub.push(addData);
            num++;
          }
        updateState2(datasub);
  };
    const dataAdd2 = (list: any): {}[] => {
    let datasub=[];
    let datasubA=[];
    let actorFlagSub = false;
      let ctgy;
        let num = 1;
        let addData={};
        for (var key in list.dtl) {
          if(list.dtl[key].colmn2=="nodata"){
            addData= {
               "id":num,
               "colmn1":intl.formatMessage({ id: list.dtl[key].colmn1 }),
               "colmn2":msg
                };
            }else if(list.dtl[key].colmn1=="langID00066"){
                setActorFlag2(true);
                actorFlagSub = true;
                let cnt = list.dtl[key].colmn2.length +" " + intl.formatMessage({ id: "langID00069" })
                setData3_3([{
               "id":"actor",
               "colmn1":intl.formatMessage({ id: list.dtl[key].colmn1 }),
               "colmn2":cnt
                }]);
                let sub3 = []
                let s3 = []
                for (let keysub in list.dtl[key].colmn2) {
                  sub3 ={
                    "name":list.dtl[key].colmn2[keysub].name,
                    "aliases":list.dtl[key].colmn2[keysub].aliases,
                    "url":list.dtl[key].colmn2[keysub].url
                };
                s3.push(sub3);
                }
                setStix2(s3);
                continue;
            }else{
               addData= {
               "id":num,
               "colmn1":intl.formatMessage({ id: list.dtl[key].colmn1 }),
               "colmn2":list.dtl[key].colmn2
                };
            }
            datasub.push(addData);
            num++;
          }
                  return datasub;
        };

  
  const [data,setData] = React.useState<Post[]>([]);
  const [data2, setData2] = React.useState([]);
  const [data2_2, setData2_2] = React.useState([]);
  const [data3_2, setData3_2] = React.useState([]);
  const [data3,setData3] = React.useState([]);
  const deleteSData2 = () => {
    setData2((data2) => data2.filter((value) => value.id == 9999999));
  // ['foo']
  };
  const deleteSData2_2 = () => {
    setData2_2((data2) => data2.filter((value) => value.id == 9999999));
  // ['foo']
  };
  const deleteSData3 = () => {
    setData3((data3) => data3.filter((value) => value.id == 9999999));
  // ['foo']
  };
  const deleteSData3_2 = () => {
    setData3_2((data3) => data3.filter((value) => value.id == 9999999));
  // ['foo']
  };
  const updateState2 = (t:any[]) => {
    let data2_flag = 0;
    t.forEach( function( value ) {
      if(data2_flag == 1){
        setData2_2((data2) => [...data2, value]);
      }else{
        setData2((data2) => [...data2, value]);
      }
      if(value.colmn1 == intl.formatMessage({ id: "langID00049" })){
        data2_flag = 1;
        setCutFlag(true);
      }
    });
  };
    const updateState3 = (t:any[]) => {
    let data2_flag = 0;
    t.forEach( function( value ) {
      if(data2_flag == 1){
        setData3_2((data3) => [...data3, value]);
      }else{
        setData3((data3) => [...data3, value]);
      }
      if(value.colmn1 == intl.formatMessage({ id: "langID00049" })){
        data2_flag = 1;
        setCutFlag2(true);
      }
    });
  };
  // const deleteSData3 = () => {
  //   setData3((data3) => data3.filter((value) => value.id == 9999999));
  // // ['foo']
  // };
  // const updateState3 = (t:any[]) => {
  //   t.forEach( function( value ) {
  //   setData3((data3) => [...data3, value]);
  //   });
  // };
  useEffect(() => {
    (async function () {
      if(count==0){
      setCount(1);
      setRelationLoad(true);
      const res = await resData();
      setActorFlag(false);
      setActorFlag2(false);
      //setData(res.relation);
      //setLoading(false);
      deleteSData2();
      deleteSData2_2();
      deleteSData3();
      deleteSData3_2();
      dataAdd(res.main[0].dtl);
      setRelationData(res);
      setCount(0);
      }
    })();
   }, [login,intl]);
   
    useEffect(() => {
    (async function () {
      if(data2.length !== 0){
        const res2 = await resData2();
        if(typeof res2 !== "undefined"){
          setData(res2.relation);
          setRelationLoad(false);
        }
      }
    })();
  }, [data2]);

   const handleClickOpen = () => {
    setOpen2(true);
  };

  const handleClose = () => {
    setOpen2(false);
  };
  const handleClickOpen3 = () => {
    setOpen3(true);
  };
  const handleClickOpen3_2 = () => {
    setOpen3_2(true);
  };

  const handleClose3 = () => {
    setOpen3(false);
  };
  const handleClose3_2 = () => {
    setOpen3_2(false);
  };
  const columns2_2 = [
  {width: 15,renderCell: (params) =>
  <div>
    {!open3 && <IconButton onClick={() => handleClickOpen3()}>
      <AddIcon />
    </IconButton>}
    {open3 && <IconButton onClick={() => handleClose3()}>
      <RemoveIcon />
    </IconButton>}
    </div>
  },
  { field: 'colmn1', width: 450 },
  { field: 'colmn2', width: 450 }
];
  const columns3_2 = [
  {width: 15,renderCell: (params) =>
  <div>
    {!open3_2 && <IconButton onClick={() => handleClickOpen3_2()}>
      <AddIcon />
    </IconButton>}
    {open3_2 && <IconButton onClick={() => handleClose3_2()}>
      <RemoveIcon />
    </IconButton>}
    </div>
  },
  { field: 'colmn1', width: 450 },
  { field: 'colmn2', width: 450 }
];
  const columns = useMemo<MRT_ColumnDef<C2List>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'ip',
        header: '',
        style: {overflow: "visible"},
        maxWidth:250,
        Cell: ({ cell ,row}) => (
          
          <Box
          sx={{
            gridTemplateColumns: '1fr',
            alignItems: 'start',
            gap: '1rem',
            minWidth:250,
            maxWidth:250,
            style: {overflow: "visible"},
          }}
        >
            {(() => {
                if(row.original.category == 1){
                    return <Chip centered label="C2/C&C Server" size="small" color='default' style={{color:'Black',width:'140px'}} skipFocusWhenDisabled  />;
                }else if(row.original.category == 2){
                    return <Chip centered label="Malware Download" size="small" color='default' style={{color:'Black',width:'140px'}} skipFocusWhenDisabled />;
                }else if(row.original.category == 4){
                  return <Chip centered label="Malware Hash" size="small" color='default' style={{color:'Black',width:'140px'}} skipFocusWhenDisabled />;
              }else {
                return <Chip centered label="Phishing" size="small" color='default' style={{color:'Black',width:'140px'}} skipFocusWhenDisabled />;
            }
            })()}
          &ensp;
                    {(() => {
                    return <Button color="primary" variant="text" size="small"  onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Coherence ID",
                      action: "Click Coherence ID",
                      label: row.original.mainWord, // Optional
                    });
                    deleteSData3();
                    //updateState3(dataAdd(row.original.dtl));
                    updateState3(dataAdd2(row.original));
                    handleClickOpen();
                    setTableCategory(row.original.category);
                    setTableName(row.original.mainWord);
              }}>{row.original.mainWord}</Button>;
               })()}

        </Box>
        ),
      },
    ],
    [data,intl],
    //end
  );
  const table2 = useMaterialReactTable({
    columns,
    data,
    state: {
    isLoading: relationLoad, //cell skeletons and loading overlay
    },
    defaultColumn: {
      minSize: 1100,
    },
    gridTemplateColumns: '1fr',
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    enableSorting: false,
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    defaultColumn: {
      minSize: 10, //allow columns to get smaller than default
      maxSize: 1100, //allow columns to get larger than default
      size: 260, //make columns wider by default
    },

  });
  type Person = {
  name: string
  url: string;
  aliases: string;
};

  const columns4 = useMemo<MRT_ColumnDef<Person>[]>(
    () => [
      {
        accessorKey: 'name', //access nested data with dot notation
        header: intl.formatMessage({ id: 'langID00066' }),
        size: 150,
      },
      {
        accessorKey: 'aliases',
        header: intl.formatMessage({ id: 'langID00067' }),
        size: 150,
      },
      {
        accessorKey: 'url', //normal accessorKey
        header: intl.formatMessage({ id: 'langID00068' }),
        size: 200,
      }
    ],
    [stix1,intl],
  );
    const table4 = useMaterialReactTable({
    columns:columns4,
    data:stix1, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    enableSorting: false,

    defaultColumn: {
      minSize: 5, //allow columns to get smaller than default
    },
  });
  const table5 = useMaterialReactTable({
    columns:columns4,
    data:stix2, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    enableSorting: false,

    defaultColumn: {
      minSize: 5, //allow columns to get smaller than default
    },
  });
    const table3 = useMaterialReactTable({
    columns : columns3,
    data: stix,
    defaultColumn: {
      minSize: 1100,
    },
    gridTemplateColumns: '1fr',
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    enableSorting: false,
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    defaultColumn: {
      minSize: 10, //allow columns to get smaller than default
      maxSize: 1100, //allow columns to get larger than default
      size: 260, //make columns wider by default
    },

  });

  const addButtonClick = (id:string) => {
        if(keyword !==""){
        ReactGA.event({
      category: "Search Button",
      action: "Search Button",
      label: keyword, // Optional
    });
    const aaa = document.getElementById(id);
    aaa?.click();
        }
          
    };
  

  const handleChange = (event:SelectChangeEvent) => {
    setCategory(event.target.value);
    
  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
    
  }
  const autosizeOptions={ expand: true, includeOutliers: true, includeHeaders: true };
   // TextfieldとButtonIconを合体させたコンポーネントの作成
 const AddButton = () => {
  const addButtonClick = () => {

    // document.getElementById("demo-form").submit();
    const aaa = document.getElementById("sc");
    aaa?.click();
  };
  return (
    <IconButton onClick={() => addButtonClick()}>
      <SearchIcon />
    </IconButton>
  );

};
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 0, sm: 13 },
          pb: { xs: 0, sm: 0 },
        }}
      >

            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 2 ,fontsize: "10px",height:60}}> 
        <FormControl sx={{ m: 1, minWidth: 100,marginRight:2,margin:"0 0 0 0", md: 'flex',height:60}}>
        <InputLabel id="demo-simple-select-autowidth-label" sx={{ marginTop:-1, md: 'flex'}}></InputLabel>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          //value={location.state["category"]}
          defaultValue={category}
          onChange={handleChange}
          sx={{ maxWidth:"120px"}}
        >
          <MenuItem value={0}><FormattedMessage id = "langID00005"/></MenuItem>
          <MenuItem value={1}><FormattedMessage id = "langID00006"/></MenuItem>
          <MenuItem value={2}><FormattedMessage id = "langID00007"/></MenuItem>
          <MenuItem value={3}><FormattedMessage id = "langID00008"/></MenuItem>
          <MenuItem value={4}><FormattedMessage id = "langID00009"/></MenuItem>
        </Select>
      </FormControl >
            <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
            </InputLabel>
            <TextField
              id="email-hero"
              hiddenLabel
              size="medium"
              variant="outlined"
              placeholder={intl.formatMessage({ id: "langID00016" })}
              //value={location.state["keyword"]}
              defaultValue={keyword}
              autoComplete= 'off'
              InputProps={{ endAdornment: <AddButton /> }}
              onChange={handleChangeInput}
              sx={{ m: 1, minWidth: 700,height:60}}
              onKeyDown={e => {
                // e.keyCodeは常に0になる
                    if(keyword !==""){
                if (e.key === 'Enter') {
                  // エンターキー押下時の処理
                  // document.getElementById("demo-form").submit();
                      ReactGA.event({
      category: "Search Button",
      action: "Search Button",
      label: keyword, // Optional
    });
                  const aaa = document.getElementById("sc");
                  aaa?.click();
                }
                    }
              }}
            />
            <Typography
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >

          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          ></Stack>
            </Box>
            <Link hidden id="sc" to="/search" state={{keyword:keyword,category:category}}>テキスト</Link>
      </Container>
    <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
    <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 14, sm: 0 },
          pb: { xs: 16, sm: 0 },
        }}
      >
                         
                        <Grid container spacing={2}>
                        <Grid xs={8.5}>
        <br/><br/><br/>
        <Grid  direction="row">

            {(() => {
                if(table.category == 1){
                    return <Chip centered label="C2/C&C Server" size="small" color='default' style={{backgroundColor:'purple',color:'white',width:'140px'}} skipFocusWhenDisabled />;
                }else if(table.category === 2){
                    return <Chip centered label="Malware Download" size="small" color='default' style={{backgroundColor:'red',color:'white',width:'140px'}} skipFocusWhenDisabled />;
                }else if(table.category === 3){
                  return <Chip centered label="Phishing" size="small" color='default' style={{backgroundColor:'yellow',color:'Black',width:'140px'}} skipFocusWhenDisabled />;
              }else {
                  return <Chip centered label="Malware Hash" size="small" color='default' style={{backgroundColor:'red',color:'white',width:'140px'}} skipFocusWhenDisabled />;
            }
            })()}
        &ensp;<b>{cell}</b>

        </Grid>

       
      <Box sx={{ width: '100%' }}>
      <Stack direction="row" spacing={4} sx={{ mb: 1 }}>
      </Stack>
      <DataGrid autosizeOptions={autosizeOptions} hideFooterPagination hideFooter columns={columns2} autoHeight {...data2} rows={data2} />
      {actorFlag && <DataGrid autosizeOptions={autosizeOptions} hideFooterPagination hideFooter columns={columns2_2} autoHeight {...data2_3} rows={data2_3} />}
      {actorFlag && <div className="actor2">{open3 && <MaterialReactTable table={table4} />}</div> }
      {cutFlag && <DataGrid autosizeOptions={autosizeOptions} hideFooterPagination hideFooter columns={columns2} autoHeight {...data2_2} rows={data2_2} />}


    </Box>
    </Grid>
    <Grid xs={3.5}>
    <br/><br/><br/>
    {isEditing && <b><FormattedMessage id = "langID00039" /></b> }
    {isEditing && <MaterialReactTable table={table2} />}
</Grid></Grid>
      <Dialog
        open={open2}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        sx={{
      "& .MuiDialog-container": {
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: "80%",  // Set your width here
        },
      },
    }}
      >
        
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack my={1} direction="row" justifyContent="end" spacing={1}>
          <IconButton aria-label="delete" onClick={handleClose}  sx={{zIndex: 10000}} >
            <CloseIcon />
          </IconButton>
          </Stack>
          
            {(() => {
                if(tableCategory == 1){
                    return <Chip centered label="C2/C&C Server" size="small" color='default' style={{backgroundColor:'purple',color:'white',width:'140px'}} skipFocusWhenDisabled />;
                }else if(tableCategory === 2){
                    return <Chip centered label="Malware Download" size="small" color='default' style={{backgroundColor:'red',color:'white',width:'140px'}} skipFocusWhenDisabled />;
                }else if(tableCategory === 3){
                  return <Chip centered label="Phishing" size="small" color='default' style={{backgroundColor:'yellow',color:'Black',width:'140px'}} skipFocusWhenDisabled />;
              }else {
                  return <Chip centered label="Malware Hash" size="small" color='default' style={{backgroundColor:'red',color:'white',width:'140px'}} skipFocusWhenDisabled />;
            }
            })()}
          &ensp;<b>{tableName}</b>
          
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
           {open2&&<DataGrid hideFooterPagination hideFooter columns={columns2} autoHeight {...data3} rows={data3} />}
            {actorFlag2 && <DataGrid autosizeOptions={autosizeOptions} hideFooterPagination hideFooter columns={columns3_2} autoHeight {...data3_3} rows={data3_3} />}
            {actorFlag2 && <div className="actor2">{open3_2 && <MaterialReactTable table={table5} />}</div> }
            {cutFlag2 && <DataGrid autosizeOptions={autosizeOptions} hideFooterPagination hideFooter columns={columns2} autoHeight {...data3_2} rows={data3_2} />}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </Container>
    </Box>
    
  );
}